import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from 'react-router-dom'
import { track } from 'analytics'

interface PublicRouteProps {
    children: React.ReactNode
    /** Optional custom page name for tracking, defaults to pathname */
    pageName?: string
}

/**
 * Wrapper component for public routes that tracks page views for unauthenticated users
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children, pageName }) => {
    const { isAuthenticated } = useAuth0()
    const location = useLocation()

    useEffect(() => {
        // Only track for unauthenticated users
        if (!isAuthenticated) {
            const pageTitle = document.title
            const pageUrl = window.location.href
            const trackingPageName = pageName || location.pathname

            track('www Landing Page Viewed', {
                'Page Title': pageTitle,
                'Page URL': pageUrl,
                'Page Name': trackingPageName,
                'Page Path': location.pathname
            })
        }
    }, [isAuthenticated, location.pathname, pageName])

    return <>{children}</>
}

export default PublicRoute